export interface RoomLayoutMeta {
  title: string;
  description: string;
}

export const ROOM_LAYOUT_META: Record<string, RoomLayoutMeta> = {
  classroom: {
    title: 'Classroom style',
    description: 'Training and lecture style.',
  },
  conference: {
    title: 'Conference room',
    description: 'Traditional boardroom table setup.',
  },
  pods: {
    title: 'Pods',
    description: 'Small group breakout sessions.',
  },
  ushape: {
    title: 'U-Shaped setup',
    description: 'Open discussion and presentation.',
  },
  ushaped: {
    title: 'U-Shaped setup',
    description: 'Open discussion and presentation.',
  },
  auditorium: {
    title: 'Auditorium setup',
    description: 'Large audience presentations.',
  },
  theater: {
    title: 'Theater style',
    description: 'Rows facing a stage or screen.',
  },
  boardroom: {
    title: 'Boardroom',
    description: 'Executive meeting layout.',
  },
  theatre: {
    title: 'Theatre style',
    description: 'Rows facing a stage or screen.',
  },
  collaborative: {
    title: 'Collaborative',
    description: 'Open layout for team collaboration.',
  },
  collaboration: {
    title: 'Collaboration',
    description: 'Open layout for team collaboration.',
  },
  hollowsquare: {
    title: 'Hollow square',
    description: 'Open center for group discussion.',
  },
  standingroomonly: {
    title: 'Standing room',
    description: 'Standing-only arrangement.',
  },
  banquet: {
    title: 'Banquet',
    description: 'Formal dining table layout.',
  },
};

export const getRoomLayoutMeta = (code: string): RoomLayoutMeta => {
  // Direct match (lowercase keys like 'classroom', 'conference')
  if (ROOM_LAYOUT_META[code]) {
    return ROOM_LAYOUT_META[code];
  }

  // Normalize: lowercase, strip hyphens/underscores/spaces
  const normalizedCode = code.toLowerCase().replace(/[-_\s]/g, '');
  if (ROOM_LAYOUT_META[normalizedCode]) {
    return ROOM_LAYOUT_META[normalizedCode];
  }

  // Search by title match (handles codes like 'Classroom style', 'U-Shaped setup')
  const byTitle = Object.values(ROOM_LAYOUT_META).find(
    (meta) => meta.title.toLowerCase() === code.toLowerCase()
  );
  if (byTitle) {
    return byTitle;
  }

  // Search by partial match (handles 'Classroom', 'CLASSROOM', etc.)
  const byPartial = Object.entries(ROOM_LAYOUT_META).find(
    ([key]) => normalizedCode.startsWith(key) || key.startsWith(normalizedCode)
  );
  if (byPartial) {
    return byPartial[1];
  }

  // Fallback: use the code as title (sentence case per Figma)
  const title = code
    .replace(/[-_]/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase())
    .trim();
  return { title, description: '' };
};
